export default "__VITE_ASSET__a559e154__"